import ListCardSkeleton from "@shared/components/card/skeleton/list-card-skeleton";
import RectangularSkeleton from "@shared/components/skeleton/RectangleSkeleton";
import BookIcon from "@svg/new-design/book";
import { FC } from "react";

export const InstructorProductCardsSkeleton: FC = () => (
  <>
    {Array.from({ length: 6 }, (_, idx) => (
      <ListCardSkeleton key={idx} withBorder />
    ))}
  </>
);

const InstructorsProductsSkeleton: FC = () => (
  <div className="fds-l:px-6 pt-6 mb-6 fds-l:mb-0" id="instructorProducts">
    <div className="flex items-center">
      <BookIcon className="fds-l:hidden block ml-1 fds-l:ml-0 w-6 h-6 text-fds-icon-tertiary" />
      <p className="fds-l:headline-lg headline-sm">آموزش‌های مدرس</p>
    </div>

    <div className="mt-1 mb-4 fds-l:mb-8 fds-l:mt-2.5 border-b border-b-fds-default pb-3">
      <RectangularSkeleton height={20} width={180} />
    </div>

    <div className="flex flex-col mt-4 fds-l:mt-6 gap-y-6">
      <InstructorProductCardsSkeleton />
    </div>
  </div>
);

export default InstructorsProductsSkeleton;
